export default __webpack_public_path__ + "static/media/icon-question.d43abce3.png";